import { render, staticRenderFns } from "./ArticleSearch.vue?vue&type=template&id=1ca559c0&scoped=true&"
import script from "./ArticleSearch.vue?vue&type=script&lang=js&"
export * from "./ArticleSearch.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSearch.vue?vue&type=style&index=0&id=1ca559c0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca559c0",
  null
  
)

export default component.exports